import React from "react";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { colors } from "utils";

// "Release this group code?" (Figma 4253-25373): the confirmation a quick
// group's Archive Group opens, on today's card and on the one-list card.

const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
`;

const ConfirmHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

const ConfirmTitle = styled.h2`
  color: ${colors.nightlyWoods500};
  font-family: "ABC Marfa", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin: 0;
`;

const CloseIconButton = styled.button`
  align-items: center;
  background: transparent;
  border: 2px solid #00140b;
  border-radius: 100px;
  color: #00140b;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  width: 48px;
`;

const ConfirmBody = styled.p`
  color: ${colors.nightlyWoods500};
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 26px;
  margin: 0;
`;

const ConfirmActions = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: flex-end;
`;

const ModalButton = styled.button`
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  height: 48px;
  letter-spacing: 0.25px;
  padding: 0 16px;
  white-space: nowrap;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const KeepButton = styled(ModalButton)`
  background: #fff;
  border: 1px solid ${colors.blue500};
  color: ${colors.blue500};
`;

const ReleaseButton = styled(ModalButton)`
  background: ${colors.blue500};
  border: 1px solid ${colors.blue500};
  color: #faf7f2;
`;

const XIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const ReleaseGroupCodeModal = ({ isOpen, releasing, onClose, onRelease }) => (
  <Modal
    show={isOpen}
    onHide={() => { if (!releasing) onClose(); }}
    centered
    contentClassName="qg-release-modal-content"
  >
    <ConfirmContainer>
      <ConfirmHeader>
        <ConfirmTitle>Release this group code?</ConfirmTitle>
        <CloseIconButton type="button" aria-label="Close" onClick={onClose} disabled={releasing}>
          <XIcon />
        </CloseIconButton>
      </ConfirmHeader>
      <ConfirmBody>
        This removes this card from your dashboard and makes the code available to use with another group. Students will no longer be able to log in with this code until it is reassigned. Don’t worry, your Teacher Reports are not impacted by this action.
      </ConfirmBody>
      <ConfirmActions>
        <KeepButton type="button" onClick={onClose} disabled={releasing}>
          Keep Group Code
        </KeepButton>
        <ReleaseButton type="button" onClick={onRelease} disabled={releasing}>
          {releasing ? "Releasing…" : "Yes, Release"}
        </ReleaseButton>
      </ConfirmActions>
    </ConfirmContainer>
  </Modal>
);
